import styled from 'styled-components';

export const PageContainer = styled.div`
  position: relative;
  display: flex;
  background: ${({ theme }) => theme.onSurface.surface.default.background};
`;

export const PageBackground = styled.div`
  height: 100vh;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
